"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var useMount = function useMount(fn) {
  react_1.useEffect(function () {
    fn();
  }, []);
};

exports["default"] = useMount;